import React, { useCallback, useEffect, useState } from "react";
import { Form } from "antd";
import { isEmpty } from "lodash-es";
import { SDrawerOrModal, SGeneralForms } from "shj-components";
import { httpOrgList } from "@/services/homeService.ts";
import {
  getProductList,
  getProductManagementPage,
  warningRulesGlobalProduct,
  warningRulesGlobalProductUpdate, warningRulesGlobalStore, warningRulesGlobalStoreUpdate,
} from "@/services/product.ts";
import DebounceSelect from "@/pages/baseProduct/components/DebounceSearchSelect";
import { useSetState } from "ahooks";

const AddOrEditModal = (props) => {
  const {open, onClose, onReload} = props;
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [state, setState] = useSetState({
    orgIds: [],
    productIds: [],
    orgEnumId: '',
    productEnumId: '',
  })

  useEffect(() => {
    form.setFieldsValue({orgIds: state?.orgIds, productIds: state?.productIds})
  }, [state, form]);

  const getInfo = useCallback(async () => {
    try {
      setLoading(true)
      await warningRulesGlobalStore().then(res => {
        setState({orgIds: res?.company?.map(item => item.id), orgEnumId: res?.id})
      });
      await warningRulesGlobalProduct().then(res => {
        const productIds = res?.product?.map(item => item.id)
        setState({productIds, productEnumId: res?.id})
      })
    } finally {
      setLoading(false)
    }

  }, [setState])

  useEffect(() => {
    getInfo()
  }, [open, getInfo]);

  const getOptions = async () => {
    const companyList = await httpOrgList({enabled: true})
    const productList = await getProductList({ prodType: 'PRODUCT_PACKAGE', enabled: true })
    return {companyList, productList}
  }

  const onSubmit = () => {
    form.validateFields().then( async (values) => {
      setLoading(true)
      try {
        await warningRulesGlobalStoreUpdate({
          id: state?.orgEnumId,
          orgIds: values?.orgIds,
        })
        await warningRulesGlobalProductUpdate({
          id: state?.productEnumId,
          productIds: values?.productIds,
        })
      } finally {
        onReload()
        onClose()
        setLoading(false)
      }
    })
  }

  return <SDrawerOrModal
    mode={'modal'}
    width={500}
    title={'编辑配置'}
    okText={'确定'}
    open={open}
    onCancel={onClose}
    onOk={onSubmit}
    loading={loading}
  >
    <SGeneralForms
      layout={'vertical'}
      formConfig={{form}}
      httpOptionsFn={getOptions}
      configs={[{
        formItem: [
          {
            spanCol: 24,
            label: '查询门店',
            name: 'orgIds',
            type: 'select',
            data: 'companyList',
            comConfig: {
              mode: 'multiple',
              fieldNames: {label: 'name', value: 'id'}
            }
          },
          {
            spanCol: 24,
            label: '查询产品',
            name: 'productIds',
            type: 'select',
            data: 'productList',
            comConfig: {
              fieldNames: { label: 'prodName', value: 'id' },
              mode: 'multiple',
            },
          },
        ]
      }]}/>
  </SDrawerOrModal>
}

export { AddOrEditModal }